// @flow

export default function toBoolean(value: any): boolean {
  return !!value;
}



// WEBPACK FOOTER //
// ./app/utils/toBoolean.js